import React, { useState } from "react";
import { DownOutlined } from "@ant-design/icons";
import { MobileOptionPicker } from "../MobilePicker/MobileOptionPicker";

export interface SelectOption {
  label: string;
  value: any;
  disabled?: boolean;
}

interface SelectInputProps {
  /**
   * 选项列表
   */
  options: SelectOption[];
  /**
   * 当前选中值
   */
  value?: any;
  /**
   * 值变化回调
   */
  onChange?: (value: any) => void;
  /**
   * 占位符
   */
  placeholder?: string;
  /**
   * 选择器标题
   */
  title?: string;
  /**
   * 是否只读
   */
  readOnly?: boolean;
  /**
   * 自定义样式
   */
  style?: React.CSSProperties;
}

/**
 * 移动端选择输入组件
 * 结合 renderPickerTrigger 和 MobileOptionPicker 的通用组件
 */
export const SelectInput: React.FC<SelectInputProps> = ({
  options,
  value,
  onChange,
  placeholder = "請選擇",
  title = "請選擇",
  readOnly = false,
  style,
}) => {
  const [pickerVisible, setPickerVisible] = useState(false);

  // 根据 value 查找对应的 label
  const getLabel = () => {
    const option = options.find((opt) => opt.value === value);
    return option?.label;
  };

  const handleChange = (newValue: any) => {
    onChange?.(newValue);
    setPickerVisible(false);
  };

  const label = getLabel();

  return (
    <>
      <div
        onClick={!readOnly ? () => setPickerVisible(true) : undefined}
        style={{
          border: "1px solid #CBD5E1",
          borderRadius: "6px",
          padding: "0 16px",
          cursor: readOnly ? "not-allowed" : "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: readOnly ? "#f5f5f5" : "#fff",
          height: 40,
          width: "100%",
          ...style,
        }}
      >
        <span
          style={{
            color: label ? "#334255" : "var(--placeholder-color)",
            fontSize: 16,
            fontWeight: 400,
          }}
        >
          {label || placeholder}
        </span>
        {!readOnly && <DownOutlined style={{ color: "var(--placeholder-color)", fontSize: 12 }} />}
      </div>

      <MobileOptionPicker
        visible={pickerVisible}
        onClose={() => setPickerVisible(false)}
        title={title}
        options={options}
        value={value}
        onChange={handleChange}
      />
    </>
  );
};
